export const languages = [
  {
    label: 'Bengali',
    value: 'Bengali',
  },
  {
    label: 'Mandarin',
    value: 'Mandarin',
  },
  {
    label: 'Malay',
    value: 'Malay',
  },
  {
    label: 'Indonesian',
    value: 'Indonesian',
  },
  {
    label: 'Tamil',
    value: 'Tamil',
  },
  {
    label: 'Burmese',
    value: 'Burmese',
  },
  {
    label: 'Laotian',
    value: 'Laotian',
  },
  {
    label: 'Nepali',
    value: 'Nepali',
  },
  {
    label: 'Arabic',
    value: 'Arabic',
  },
  {
    label: 'Spanish',
    value: 'Spanish',
  },
];

export const tones = [
  {
    label: 'Fact-First',
    value: 'Fact-First',
  },
  {
    label: 'Assertion',
    value: 'Assertion',
  },
  {
    label: 'Concern',
    value: 'Concern',
  },
  {
    label: 'Neutral',
    value: 'Neutral',
  },
  {
    label: 'Human-First',
    value: 'Human-First',
  },
  {
    label: 'Question',
    value: 'Question',
  },
  {
    label: 'Humor',
    value: 'Humor',
  },
  {
    label: 'Critical of China',
    value: 'Critical of China',
  },
];

export const creativityOptions = [
  { value: 'Creative', label: 'Creative' },
  { value: 'Balanced', label: 'Balanced' },
  { value: 'Strict', label: 'Strict' },
];

export type OptionType = { value: string; label: string };
